<template><section><h2>Challenge Descriptions</h2>
<p>目前，我国大气污染防治成效显著，这得益于我国逐渐完善的空气质量监测网。近年来，空气质量监测站收集到大量具有高维、时序特点的空气质量数据，如何利用此类数据，分析理解大气污染传输模式，并为决策者提供有效建议十分具有挑战性。利用大数据分析技术和可视化方法，能够分析大气污染问题及成因、监测大气污染发展趋势、分析大气污染的地域相关性，快速感知大气污染的时变规律，辅助工作人员因地制宜地制定防治策略。大数据可视分析与可视化将数据智能处理、视觉表征和交互分析有机地结合，使机器智能和人类智慧深度融合、优势互补，为大气污染防治工作的分析、指挥和决策提供有效手段和决策依据。第八届中国可视化与可视分析大会数据可视化竞赛向相关研究人员、高校师生、企业和数据可视分析爱好者、艺术家征集相关数据可视分析和艺术可视化作品。</p>
<h2>Project Task</h2>
<p>参赛作品要求利用竞赛提供的2013–2018年中国高分辨率大气污染再分析开放数据集（http://naq.cicidata.top:10443/chinavis/opendata），利用可视分析技术与可视化方法，探索并发现空气质量大数据背后隐藏的模式和规律。该数据是覆盖全国范围的基于地理空间网格的空气质量再分析数据和对应的气象数据，包括六项常规污染物、风速、温度、气压、相对湿度和经纬度在内的13个属性（详细数据说明请登录开放数据集网站）。</p>
<ul>
<li>大气污染源分析：利用可视分析技术，识别主要大气污染源，分析关键污染成因。（可以根据自身情况联合其他数据辅助分析）</li>
<li>大气污染时空态势分析：利用可视分析技术，分析大气污染时空分布模式、监控大气污染时空演变态势。</li>
<li>大气污染传输模式分析：利用可视分析技术，比较各地大气污染物差异、大气污染传输模式、检测异常传输事件，制定传输防治策略。</li>
<li>大气污染预测：利用可视分析技术，预测大气污染发展趋势、重污染天气预警。</li>
<li>大气环境的改善：利用可视分析技术，展示大气污染治理过程中的大气环境状况、评估大气污染防治措施。</li>
<li>自选主题，提炼分析需求，设置分析问题，并提供解决方案。</li>
</ul>
<h2>Schedule</h2>
<ul>
<li>
<p>Fetch Dataset, analyse tasks, and make a plan to solve it (2-3 week)</p>
</li>
<li>
<p>Process data, implement analysis framework (4-7 week)</p>
</li>
<li>
<p>Mid-term inspection (8 week)</p>
</li>
<li>
<p>Implement analysis system (9-12 week)</p>
</li>
<li>
<p>Inter-team evaluation and modification (13-15 week)</p>
</li>
<li>
<p>Final inspection (16-17 week)</p>
</li>
</ul>
<h2>Resources</h2>
<ul>
<li>http://www.chinavis.org/2021/challenge.html</li>
</ul>
</section></template><script>export default {components:{}}</script>